import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink-deep text-white" data-id="element-101" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-102" data-mp="3gfsp4jdu96q5">
        <h3 className="font-display text-2xl font-extrabold tracking-tight text-white" data-id="element-103" data-mp="3gh3rcermy6f5">
          52 Weeks <span className="text-amber" data-id="element-104" data-mp="32m1awxp5wyo3">of Speaking</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-105" data-mp="36pzatambadi7">
          A full year of ready-to-run public speaking sessions — open the page and teach in minutes.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-white/70" data-id="element-106" data-mp="37o7iyd163ey">
          <a href="mailto:help@iclcollective.com" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-107" data-mp="3ldkdj3f9yapl">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-ink-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-108" data-mp="29ydvry6nv08u">
          52 Weeks of Speaking is a teaching resource for public speaking teachers,
          coaches and speaking-club leaders. It is not affiliated with or endorsed by
          Toastmasters International, TED or any other speaking organization, school
          board or exam body. It is speaking-practice material, not therapy or medical
          advice for anxiety. Results depend on the teacher and the group; no specific
          outcome is guaranteed. © 52 Weeks of Speaking 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}